/**
 * URL.js
 *
 * Copyright (c) apploft. GmbH
 */
import { findGet, findPost, findPut, findDelete } from './Path';
import { url } from './APIDefinition';

function createPostUrl(_ref) {
  var api = _ref.api,
      paths = _ref.paths;

  var _findPost = findPost(paths),
      name = _findPost.pathID.name;

  return url(name, api);
}

function appendObjectId(name, objectId) {
  if (typeof objectId !== 'string') {
    return name;
  }

  var tokens = name.split('{');
  var first = tokens[0];
  return [first, objectId].join('');
}

function createSinglyUrl(findPath, _ref2) {
  var api = _ref2.api,
      paths = _ref2.paths,
      _ref2$objectId = _ref2.objectId,
      objectId = _ref2$objectId === void 0 ? null : _ref2$objectId;
  var path = findPath(paths, objectId);

  if (!path || typeof path !== 'object') {
    return null;
  }

  var name = path.pathID.name;
  return url(appendObjectId(name, objectId), api);
}
/**
 * Returns GET URL using props.
 *
 * @param {{api: *, paths: [*], objectId?: string}} props
 */


function createGetUrl(props) {
  return createSinglyUrl(findGet, props);
}
/**
 * Returns PUT URL using props.
 *
 * @param {{api: *, paths: [*], objectId: string}} props
 */


function createPutUrl(props) {
  return createSinglyUrl(findPut, props);
}
/**
 * Returns DELETE URL using props.
 *
 * @param {{api: *, paths: [*], objectId: string}} props
 */


function createDeleteUrl(props) {
  return createSinglyUrl(findDelete, props);
}

export { createGetUrl, createPostUrl, appendObjectId, createPutUrl, createDeleteUrl };